/**
 * Hero "Escribe su nombre": avisa si se envía el campo vacío.
 * El formulario es un GET normal hacia la ficha del tarro (?frase=...), así que funciona sin JavaScript.
 * La vista previa en vivo del vinilo es el componente <mb-vinilo> (assets/mb-vinilo.js), que sigue al campo por su id.
 */

/** @param {string} valor */
const limpiar = (valor) => valor.replace(/\s+/g, ' ').trim();

class MbHeroNombre extends HTMLElement {
  /** @type {AbortController | null} */
  #controller = null;
  /** @type {HTMLInputElement | null} */
  #campo = null;
  /** @type {HTMLElement | null} */
  #aviso = null;

  connectedCallback() {
    this.#campo = this.querySelector('[data-mb-campo]');
    this.#aviso = this.querySelector('[data-mb-aviso]');
    if (!this.#campo) return;

    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.#campo.addEventListener('input', () => this.#alEscribir(), { signal });
    this.#campo.form?.addEventListener('submit', (evento) => this.#alEnviar(evento), { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }

  #alEscribir() {
    this.#campo?.removeAttribute('aria-invalid');
    if (this.#aviso) this.#aviso.textContent = '';
  }

  /** @param {SubmitEvent} evento */
  #alEnviar(evento) {
    if (!this.#campo) return;
    const escrito = limpiar(this.#campo.value);

    if (escrito === '') {
      evento.preventDefault();
      this.#campo.value = '';
      this.#campo.setAttribute('aria-invalid', 'true');
      this.#avisar(this.dataset.avisoVacio ?? '');
      this.#campo.focus();
      return;
    }

    // Se envía recortado; el GET del formulario construye ?frase=<texto> por sí solo
    this.#campo.value = escrito;
  }

  /** @param {string} mensaje */
  #avisar(mensaje) {
    if (!this.#aviso) return;
    const aviso = this.#aviso;
    // Vaciar y volver a escribir hace que el lector de pantalla lo anuncie siempre
    aviso.textContent = '';
    requestAnimationFrame(() => {
      aviso.textContent = mensaje;
    });
  }
}

if (!customElements.get('mb-hero-nombre')) {
  customElements.define('mb-hero-nombre', MbHeroNombre);
}
